module.exports = __webpack_public_path__ + "static/img/Italy.fe6f437.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/destination/Italy.jpg
// module id = n1wo
// module chunks = 1